import React from "react";
import {
  TypesBadgePinRegistrationRequestValidation,
  TypesOtpRegistrationPinRequestValidation,
} from "@amzn/frontier-rtk-query-client";

export type PinType = "badge" | "OTP";

interface PinPreset {
  type: PinType;
  pinRegex: RegExp;
  invalidPinMessage: string;
  pinDescription: string;
  inputMode?: "text" | "numeric";
  infoText: React.ReactNode;
}

const otpPin = TypesOtpRegistrationPinRequestValidation.pin;
const badgePin = TypesBadgePinRegistrationRequestValidation.pin;

const lengthRangeText = (min: number | undefined, max: number | undefined) => {
  if (min !== undefined && max !== undefined) return `${min}-${max}`;
  if (min !== undefined) return `at least ${min}`;
  if (max !== undefined) return `at most ${max}`;
  return "";
};

export const OTP_PIN_PRESET: PinPreset = {
  type: "OTP",
  pinRegex: new RegExp(otpPin.pattern),
  invalidPinMessage: "Invalid PIN.",
  pinDescription: `Enter a new PIN consisting of ${lengthRangeText(otpPin.minLength, otpPin.maxLength)} numbers and/or letters.`,
  infoText: (
    <>
      Create and confirm a new PIN consisting of letters and numbers and then
      click the &ldquo;Set PIN&rdquo; button.
    </>
  ),
};

export const BADGE_PIN_PRESET: PinPreset = {
  type: "badge",
  pinRegex: new RegExp(badgePin.pattern),
  invalidPinMessage: `PIN must be ${lengthRangeText(badgePin.minLength, badgePin.maxLength)} digits.`,
  pinDescription: `Enter a new PIN consisting of ${lengthRangeText(badgePin.minLength, badgePin.maxLength)} digits.`,
  inputMode: "numeric",
  infoText: (
    <>
      This PIN is used with the Badge + PIN login flow{" "}
      <b>and is separate from your corporate badge PIN</b>. Create and confirm a
      new PIN consisting of digits only and then click the &ldquo;Set PIN&rdquo;
      button.
    </>
  ),
};
